<ui-input
  [label]="label()"
  [showOptionalHint]="showOptionalHint()"
  [block]="true"
  [required]="required()"
  [maxlength]="maxLength()"
  [disabled]="disabled()"
  [invalid]="invalid()"
  [message]="message()"
  [value]="masked()"
  (valueChange)="onValue($event)"
  (focused)="onFocus($event)"
/>
